import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import VideoModal from "../../../../components/userSide/modals/vidModal";


const styles = (theme) => ({
	root: {
		maxWidth: 345,
	},
	media: {
		height: 300,
		// margin: "5px",
	},
});

class MediaCard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			vidModal: false,
		};
	}

	toggle = () => {
		this.setState({
			modalVisible: !this.state.modalVisible,
			videoPlaying: !this.state.videoPlaying,
		});
	};

	render() {
		const { classes } = this.props;
		return (
			<div>
				<div className="grow">
					<VideoModal
						that={this}
						opener={this.state.vidModal}
						videoLink={this.props.url}
					/>

					<Card
						className={classes.root}
						onClick={() => {
							this.setState({ vidModal: true });
						}}
					>
						<CardActionArea>
							<CardMedia
								className={classes.media}
								image={this.props.thumbnail}
								title="Course Card"
							/>
							<CardContent>
								<Typography
									gutterBottom
									variant="h5"
									component="h2"
								>
									{this.props.title}
								</Typography>
							</CardContent>
						</CardActionArea>
					</Card>
				</div>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(MediaCard);
